export function generateID() {
  return parseInt(Math.random()*10000000)
}

export function uniqueKey() {
  return Math.random().toString(36).substring(7);
}